<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  usersData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : usersData.length
                }}
                de {{ usersData.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Buscar..."
        />
        <vs-button
          class="p-3 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-primary border border-solid border-primary"
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-plus"
          @click="addNewData"
          >Agregar Nuevo</vs-button
        >
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        :modules="modules"
      />

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />

      <!-- Parents verification modal -->
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "@ag-grid-community/vue"
import {AllCommunityModules} from '@ag-grid-community/all-modules';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue"
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import CellRendererRol from "./cell-renderer/CellRendererRol.vue"


export default {
  props: {
    profile_type: {
      type: String,
      default: 'admin',
      required: true
    }
  },
  components: {
    AgGridVue,
    vSelect,
    CellRendererStatus,
    CellRendererActions,
    CellRendererRol
  },
  data() {
    return {
      modules: AllCommunityModules,
      searchQuery: "",
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: false,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 150,
          filter: false,
        },
        {
          headerName: 'Email',
          field: 'email',
          filter: false,
          width: 300,
          cellStyle: {'text-transform': 'lowercase'}
        },
        {
          headerName: 'Nombre',
          field: 'full_name',
          filter: false,
          width: 300,
        },
        {
          headerName: 'Rol',
          field: 'profile_type',
          filter: false,
          width: 130,
          cellRendererFramework: 'CellRendererRol'
        },
        // {
        //   headerName: 'Estudiantes',
        //   field: 'pupils',
        //   filter: false,
        //   width: 300,
        //   hide: this.profile_type !== 'parents',
        //   cellClass: 'overflow-x-auto overflow-clip',
        //   valueGetter: function(params) {
        //     return params.data.pupils.map(e => e.full_name).join(', ')
        //   }
        // },
        {
          headerName: 'Estado',
          field: 'status',
          filter: false,
          // width: 150,
          cellRendererFramework: 'CellRendererStatus'
        },
        {
          headerName: 'Acciones',
          field: 'transactions',
          // width: 150,
          cellRendererFramework: 'CellRendererActions',
        },
      ],
      // Cell Renderer Components
      components: {
        CellRendererStatus,
        CellRendererActions,
        CellRendererRol,
      },
    }
  },
  computed: {
    usersData() {
      if (this.profile_type === 'admin') {
        if(this.$acl.check('admin'))
          return this.$store.state.userManagement.owners

        if(this.$acl.check('manager'))
          return this.$store.state.userManagement.users
      } else if (this.profile_type === 'parents') {
        return this.$store.state.userManagement.parents || [];
      }
      return [];
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    addNewData() {
      if (this.profile_type === 'admin')
        this.$router.push("/users/user-add/").catch((error) => {console.log(error)})
      else if (this.profile_type === 'parents') {
        this.$router.push('/users/user-add?profileType=1').catch((error) => {console.log(error)})
      }
    },
    loadAccountTable() {
      this.$store.dispatch("userManagement/getParents")
        .then((response) => {
          if (response.data.length > 0) {
            let s = JSON.parse(JSON.stringify(response.data));

            s.forEach(e => {
              e.birthday_date = e.birthday_date ? new Date(e.birthday_date).toLocaleDateString('es-AR', this.$localeDateOptions) : "";
              e.end_at = e.end_at ? new Date(e.end_at).toLocaleDateString('es-AR', this.$localeDateOptions) : "";
              e.created_at = e.created_at ? new Date(e.created_at).toLocaleDateString('es-AR', this.$localeDateOptions) : "";
            })

            return s;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
  },
  created() {
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    if (this.profile_type === 'admin') {
      if(this.$acl.check('admin'))
        this.$store.dispatch("userManagement/getOwners").catch(err => { console.error(err) })

      if(this.$acl.check('manager'))
        this.$store.dispatch("userManagement/getStaff", this.$store.state.AppActiveUser.institution.id).catch(err => { console.error(err) })
    }

    this.loadAccountTable()
  }
}

</script>

<style lang="scss">
  #page-user-list {
    .user-list-filters {
      .vs__actions {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-58%);
      }
    }
  }
  .con-vs-popup.popup-zindex {
    z-index: 51800 !important;
  }
  input[type="number"] {
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    -moz-appearance: textfield;
  }
</style>
